import { createFileRoute } from '@tanstack/react-router'
import { MaximoWorkOrders } from 'pages/maximoWorkOrders/MaximoWorkOrders'
import { maximoSearchParamsSchema } from 'routes/maximo/-searchParams'

const RouteComponent = () => {
  const { siteId } = Route.useSearch()

  return <MaximoWorkOrders siteID={siteId} />
}

export const Route = createFileRoute('/maximo/')({
  component: RouteComponent,
  validateSearch: maximoSearchParamsSchema,
  staticData: {
    title: 'Maximo Work Orders',
  },
})
